import api from './api';

const publicService = {
  /**
   * Get the latest PRO artists (public)
   * @returns {Promise<Array>} List of latest PRO artists
   */
  async getLatestProArtists() {
    const response = await api.get('/api/public/potential');
    return response.data;
  },

  /**
   * Get the public info
   * @returns {Promise<Object>} Public info
   */
  async getPublicInfo() {
    const response = await api.get('api/public/info');
    return response.data;
  },

  /**
   * Get the location settings
   * @returns {Promise<Object>} Location settings
   */
  async getLocationSettings() {
    const response = await api.get('api/user-location');
    return response.data;
  },

  /** Get public artist catalog
   * Example call: https://indiefy.net/v1/api/artists?published=1&limit=25&page=0&search=&orderBy[]=spotify_followers&orderBy[]=popularity
   * @param {Object} params - Query parameters
   * @param {number} params.published - Whether the artist is published (default: 1)
   * @param {number} params.pro - Filter by PRO status (optional)
   * @param {number} params.limit - Number of artists to return (default: 25)
   * @param {number} params.page - Page number (default: 0)
   * @param {string} params.search - Search query (optional)
   * @param {string[]} params.orderBy - Order by field (default: ['spotify_followers', 'popularity'])
   * @param {string} params.country - Filter by country code (optional)
   * @param {string} params.genre - Filter by genre (optional)
   * @param {string} params.main_genre - Filter by main genre (optional)
   * @returns {Promise<Object>} Public artist catalog
   */
  async getPublicArtists(params = {}, { signal, timeout } = {}) {
    // Set default parameters
    const defaultParams = {
      published: 1,
      pro: '',
      limit: 25,
      page: 0,
      search: '',
      orderBy: '-createdAt',
    };

    const queryParams = { ...defaultParams, ...params };

    const response = await api.get('/api/artists', { params: queryParams, signal, timeout });
    return response.data;
  },
};

export default publicService;